import { Component, OnInit } from '@angular/core';
import {DataService} from "../services/data.service";
import {ApiService} from "../services/api.service";
import {Mailchimp} from "../type/mailchimp";

@Component({
    selector: 'app-mailchimp-list',
    templateUrl: './mailchimp-list.component.html',
})
export class MailchimpListComponent implements OnInit {

    node = 'mailchimp/list';
    mailChimpList: [Mailchimp] = [Mailchimp];

    isChecked = false;
    checkedList = [];

    constructor(
        private dataService: DataService,
        private apiService: ApiService
    ) {}

    ngOnInit() {
        this.dataService.refresh();
        this.getAll();
    }

    resetData() {
        this.getAll();
        this.isChecked = false;
        this.checkedList = [];
    }

    getAll(): void {
        this.apiService.getAll(this.node)
            .subscribe(
                (response) => {
                    this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        this.mailChimpList = [{"mail_chimp_list_id":""}];
                    } else {
                        this.mailChimpList = response.json().data;
                    }
                },
                (error) => {this.mailChimpList = [{"mail_chimp_list_id":""}];}
            );
    }

    onDelete() {
        if (confirm('Are you absolutely sure you want to delete?')) {
            this.apiService.delete(this.node, this.checkedList)
                .subscribe((response) => {
                    // this.dataService.updateActiveRequestNo(-1);
                    if (response.json().error == true) {
                        alert('Unable to delete List');
                    } else {
                        alert('List Deleted Successfully');
                    }
                    this.resetData();
                });
        }
    }

    onRefreshList() {
        this.apiService.refresh(this.node)
            .subscribe((response) => {
                this.dataService.updateActiveRequestNo(-1);
                if (response.json().error == true) {
                    alert('Unable to refresh List');
                } else {
                    alert('List refreshed Successfully');
                }
                this.resetData();
            });
    }

    onSyncList() {
        this.apiService.sync(this.node)
            .subscribe((response) => {
                this.dataService.updateActiveRequestNo(-1);
                if (response.json().error == true) {
                    alert(response.json().message);
                } else {
                    alert(response.json().message);
                }
                this.resetData();
            });
    }

    updateCheckList(id) {
        if (this.checkedList.indexOf(id) == -1) {
            this.checkedList.push(id);
        } else {
            this.checkedList.splice(this.checkedList.indexOf(id), 1);
        }
    }

    toggleCheckBox() {
        this.isChecked = !this.isChecked;
        if (this.isChecked == true) {
            this.checkedList = this.mailChimpList.map(function(a) {return a.mail_chimp_list_id;});
        } else {
            this.checkedList = [];
        }
    }

    checkPermission(module, method) {
        return this.dataService.checkPermission(module, method);
    }

}



// WEBPACK FOOTER //
// ./src/app/mailchimp/mailchimp-list.component.ts